const UID_LENGTH = 16;
const TIMESTAMP_CHARS = 9;

/**
 * Extracts the millisecond timestamp encoded in an Indeed UID string (e.g. ctk).
 * A UID is 16 base32 chars where the first 9 encode the creation timestamp.
 * Logic ported from @indeed/node-uid (archived) to avoid the outdated dependency.
 * @see https://code.corp.indeed.com/node/uid/-/blob/v1.2.0/src/UID.ts
 */
export function getCtkTimestamp(ctk: string): number {
  if (!ctk || ctk.length !== UID_LENGTH) {
    return 0;
  }
  const timestamp = parseInt(ctk.slice(0, TIMESTAMP_CHARS), 32);
  return Number.isFinite(timestamp) ? timestamp : 0;
}

/**
 * Returns the age of a CTK in milliseconds, derived from the timestamp encoded
 * in the CTK string. Returns `undefined` when the CTK is missing or malformed so
 * callers can distinguish "unknown age" from "brand new".
 */
export function getCtkAge(ctk: string | null | undefined): number | undefined {
  const timestamp = getCtkTimestamp(ctk ?? "");
  if (timestamp <= 0) {
    return undefined;
  }
  return Date.now() - timestamp;
}
